import { SkeletonBox } from '@/components/SkeletonBox'
import { ExperiencesSkeleton, type ExperiencesSkeletonProps } from '@/Reservations/Search/Experiences/ExperiencesSkeleton'
import { VStack } from '@sevenrooms/ui-kit/layout'

interface PrivateEventsOtherVenuesAvailabilitySkeletonProps extends ExperiencesSkeletonProps {
  count?: number
}

export function PrivateEventsOtherVenuesAvailabilitySkeleton({ count = 3, ...props }: PrivateEventsOtherVenuesAvailabilitySkeletonProps) {
  return (
    <>
      {[...Array(count).keys()].map(val => (
        <VStack key={val} data-test="other-availability-skeleton" spacing="m" mb="xxl">
          <VStack spacing="xs">
            <SkeletonBox width="100px" height="21px" />
            <SkeletonBox width="450px" height="17px" />
          </VStack>
          <ExperiencesSkeleton {...props} />
        </VStack>
      ))}
    </>
  )
}
